// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2uScF","selects":"Documents_selects__pSNHx"};